import { render, staticRenderFns } from "./BrowserPaying.vue?vue&type=template&id=24664e68&"
import script from "./BrowserPaying.vue?vue&type=script&lang=js&"
export * from "./BrowserPaying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports